export const ChainNames = {
  MAINNET: 'casper',
  TESTNET: 'casper-test',
};
export const MINIMUM_BALANCE = '2500000000'; // 2.5 CSPR
export const AVERAGE_BLOCK_TIME = 60000;
